import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import UserDetail from '../UserDetail'
import About from '../About'
import Footer from '../Footer'
import Interests from '../Interests'
import GroupList from '../GroupList'
import MixrList from '../MixrList'
import { redirectToPage } from 'srcReact/helpers/history'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Expertises from '../Expertises'
import PromptList from '../PromptList'

function LightProfile({
  user,
  userStatus,
  profilePicture,
  organizationId,
  interests,
  prompts,
  expertises,
  interestGroups,
  expertiseGroups,
  mixrs,
  isMobile,
  screenType,
  changeScreen,
  sendMessage,
  isNative,
  showSendMessage,
  navigate,
  usersCount,
  userIndex,
  isLoggedUser,
  error
}) {
  const [commonInterestCount, setCommonInterestCount] = useState(0)
  const redirectToProfile = () => {
    if (isNative) {
      redirectToPage(`/0/profile/${user.id}/native/profile`, isNative)
      return
    }
    redirectToPage(`/0/profile/${user.id}`)
  }
  const { t } = useTranslation()

  useEffect(() => {
    const commonInterests = interests?.filter((int) => int.is_common_with_logged_user === 1)
    setCommonInterestCount(commonInterests.length)
  }, [interests])
  return error ? (
    <ErrorMessage className={styles.error} text={error} center={true} />
  ) : screenType === 'expertise-group-list' ? (
    <GroupList
      groupType='expertise'
      changeScreen={changeScreen}
      groups={expertiseGroups}
      titleCSS={styles.title}
      organizationId={organizationId}
      userId={user.id}
      screenType={screenType}
      isLoggedUser={isLoggedUser}
    />
  ) : screenType === 'interest-group-list' ? (
    <GroupList
      groupType='interest'
      changeScreen={changeScreen}
      groups={interestGroups}
      titleCSS={styles.title}
      organizationId={organizationId}
      userId={user.id}
      screenType={screenType}
      isLoggedUser={isLoggedUser}
    />
  ) : screenType === 'mixr-list' ? (
    <MixrList
      changeScreen={changeScreen}
      mixrs={mixrs}
      titleCSS={styles.title}
      organizationId={organizationId}
      userId={user.id}
      screenType={screenType}
      isLoggedUser={isLoggedUser}
    />
  ) : (
    <div className={styles.lightProfileContainer}>
      {user && user.first_name && (
        <UserDetail
          name={`${user.first_name} ${user.last_name}`}
          role={user.current_occupation}
          commonInterestCount={commonInterestCount}
          isLoggedUser={isLoggedUser}
        />
      )}
      <div
        className={styles.header}
        style={{
          backgroundImage: `url("${profilePicture}")`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}>
        {usersCount > 0 && navigate && (
          <div className={styles.navigationContainer}>
            <div
              role='button'
              aria-label={t('global.prevNavigation', { type: t('global.profile') })}
              className={`${styles.navigationButton} ${userIndex === 0 && styles.hide}`}
              onClick={() => navigate('prev')}>
              <Icon name='chevron-left24' size={'large24'} />
            </div>
            <div
              role='button'
              aria-label={t('global.nextNavigation', { type: t('global.profile') })}
              className={`${styles.navigationButton} ${userIndex === usersCount - 1 && styles.hide}`}
              onClick={() => navigate('next')}>
              <Icon name='chevron-right24' size={'large24'} />
            </div>
          </div>
        )}
      </div>
      {userStatus === 'deactivated' && (
        <ErrorMessage className={styles.inactiveUser} text={t('global.deactivatedUserMessage')} />
      )}
      <div className={styles.body}>
        {user && user.about_me && <About aboutText={user.about_me} titleCSS={styles.title} />}

        <Interests
          titleCSS={styles.title}
          interests={interests}
          isMobile={isMobile}
          commonInterestCount={commonInterestCount}
          isLoggedUser={isLoggedUser}
          firstName={user && user.first_name}
        />

        <Expertises
          titleCSS={styles.title}
          expertises={expertises}
          isMobile={isMobile}
          isLoggedUser={isLoggedUser}
          firstName={user && user.first_name}
        />

        <PromptList titleCSS={styles.title} isMobile={isMobile} user={user} isLoggedUser={isLoggedUser} />

        {expertiseGroups?.list.length > 0 && (
          <GroupList
            groupType='expertise'
            groups={expertiseGroups}
            titleCSS={styles.title}
            firstName={user?.first_name}
            changeScreen={changeScreen}
            organizationId={organizationId}
            userId={user.id}
            screenType={screenType}
            qty={5}
            isLoggedUser={isLoggedUser}
          />
        )}
        <div className={styles.groupsmixrs}>
          <h1 className={styles.title}>{t('profile_light.groupsMixrs', { username: user?.first_name })}</h1>
          {interestGroups.list?.length > 0 && (
            <GroupList
              groupType='interest'
              groups={interestGroups}
              changeScreen={changeScreen}
              organizationId={organizationId}
              userId={user.id}
              screenType={screenType}
              qty={5}
              isLoggedUser={isLoggedUser}
            />
          )}

          {mixrs && mixrs.list && mixrs.list.length > 0 && (
            <MixrList
              mixrs={mixrs}
              changeScreen={changeScreen}
              organizationId={organizationId}
              userId={user.id}
              screenType={screenType}
              qty={5}
              isLoggedUser={isLoggedUser}
            />
          )}
        </div>
      </div>
      {user && user.id && (
        <Footer
          sendMessage={sendMessage}
          showSendMessage={showSendMessage}
          userId={user.id}
          redirectToProfile={redirectToProfile}
        />
      )}
    </div>
  )
}

export default LightProfile
